import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/SocialPlatformBasic.css';

interface BasicPost {
  id: number;
  author: string;
  content: string;
  likes: number;
  comments: number;
  time: string;
}

const SocialPlatformBasic: React.FC = () => {
  const [posts, setPosts] = useState<BasicPost[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    // Simulate API call
    setTimeout(() => {
      setPosts([
        {
          id: 1,
          author: 'John Smith',
          content: 'Just had an amazing coffee this morning! ☕',
          likes: 12,
          comments: 3,
          time: '2 hours ago'
        },
        {
          id: 2,
          author: 'Sarah Johnson',
          content: 'Working on a new project today. Excited to share updates soon!',
          likes: 8,
          comments: 5,
          time: '4 hours ago'
        },
        {
          id: 3,
          author: 'Mike Davis',
          content: 'Beautiful sunset today 🌅',
          likes: 24,
          comments: 7,
          time: '6 hours ago'
        }
      ]);
      setLoading(false);
    }, 1000);
  }, []);

  const handleLike = (postId: number) => {
    setPosts(posts.map(post => 
      post.id === postId 
        ? { ...post, likes: post.likes + 1 }
        : post
    ));
  };

  if (loading) {
    return (
      <div className="social-basic-loading">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="social-platform-basic">
      <div className="header-basic-social">
        <Link to="/" className="back-button-basic-social">← Back</Link>
        <h1>Social Feed</h1>
        <span className="version-badge-basic-social">Synoppy 1.0</span>
      </div>

      <div className="posts-container-basic">
        {posts.map(post => (
          <div key={post.id} className="post-card-basic">
            <div className="post-header-basic">
              <div className="author-info-basic">
                <div className="avatar-basic">{post.author.charAt(0)}</div>
                <div>
                  <div className="author-name-basic">{post.author}</div>
                  <div className="post-time-basic">{post.time}</div>
                </div>
              </div>
            </div>
            
            <div className="post-content-basic">
              {post.content}
            </div>
            
            <div className="post-actions-basic">
              <button 
                className="like-button-basic"
                onClick={() => handleLike(post.id)}
              >
                👍 {post.likes}
              </button>
              <button className="comment-button-basic">
                💬 {post.comments}
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="upgrade-section-basic">
        <Link to="?version=1.5" className="upgrade-link-basic">
          Try Synoppy 1.5 Advanced Version →
        </Link>
      </div>
    </div>
  );
};

export default SocialPlatformBasic;